const ClassWiseAcademicPage = () => {
    return(
        <></>
    );
}

export default ClassWiseAcademicPage;